import { useQuery } from "@tanstack/react-query";
import { api, type ApiResponse } from "@/api/client";
import type { AdminMediaResponse } from "@ckgo2/shared/types";

/**
 * Fetch a single media row by id (cached). Shared by the picker, library, and editor node.
 * `GET /api/admin/upload/:id` vrací admin projekci (zdroj, ★, země, počet použití, dvojče v koši).
 */
export function useMedia(id: string | null | undefined) {
  return useQuery({
    queryKey: ["media", id],
    queryFn: () => api.get<ApiResponse<AdminMediaResponse>>(`/api/admin/upload/${id}`),
    enabled: !!id,
    staleTime: 60_000,
  });
}
